import { fleetSpeedLyPerHour, travelDurationMs, hoursToMs, scaleDurationMs, type FleetClient, type GalaxyMapResponse } from '@galaxis/shared';
import { useGameStore } from './store/game-store.ts';

/** Server GAME_SPEED (1 in production). Durations from @galaxis/shared are game durations; divide them by this. */
export function useGameSpeed(): number {
  return useGameStore(s => s.galaxyMap?.gameSpeed) ?? 1;
}

/** Real milliseconds a duration given in game hours takes on this server. */
export function gameHoursMs(hours: number, gameSpeed: number): number {
  return scaleDurationMs(hoursToMs(hours), gameSpeed);
}

export function laneDistance(map: GalaxyMapResponse | null, a: string | null, b: string | null): number | null {
  if (!map || !a || !b) return null;
  const l = map.lanes.find(x => (x.fromSystemId === a && x.toSystemId === b) || (x.fromSystemId === b && x.toSystemId === a));
  return l ? l.distance : null;
}

export interface JumpEstimate { distance: number; speed: number; durationMs: number }

/** Distance, speed and travel time of one jump for a fleet. The server stays authoritative; this is the same formula. */
export function jumpEstimate(fleet: FleetClient, map: GalaxyMapResponse | null, toSystemId: string | null): JumpEstimate | null {
  const distance = laneDistance(map, fleet.currentSystemId, toSystemId);
  if (distance === null) return null;
  const speed = fleet.stats.speedLyPerHour || fleetSpeedLyPerHour(fleet.ships.map(s => s.class));
  return { distance, speed, durationMs: travelDurationMs(distance, speed, fleet.stats.gameSpeed ?? map?.gameSpeed ?? 1) };
}
